import { Button, ButtonProps } from '@mui/material';

export const TertiaryButton = ({ sx, ...rest }: ButtonProps) => (
  <Button
    {...rest}
    sx={{
      color: '#CDBEFD',
      borderRadius: '8px',
      border: '1px solid rgba(255, 255, 255, 0.06)',
      background: 'radial-gradient(302.62% 77.77% at 0% 0%, rgba(128, 97, 229, 0.14) 0%, rgba(128, 97, 229, 0.00) 100%), radial-gradient(253.43% 70.61% at 100% 100%, rgba(128, 97, 229, 0.12) 0%, rgba(128, 97, 229, 0.00) 100%), #2A2A32',
      minWidth: 'min-content',
      [':hover']: {
        border: '1px solid rgba(255, 255, 255, 0.12)',
        backgroundColor: '#36363f',
      },
      ...sx,
    }}
  />
);
